export default "__VITE_ASSET__DMWsyvX3__"